import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import * as MarcasCrud from 'services/marca.service'

const MarcaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [marcas, setMarcas] = React.useState([])

  React.useEffect(() => {
    MarcasCrud.getMarcas_Select().then(({ data }) => setMarcas(data))
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MARCA' htmlFor='select-marca' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='_idMarca'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-marca'
            >
              <option value=''>Seleccionar</option>
              {marcas &&
                marcas.map((val, key) => (
                  <option key={key} value={val._id}>
                    {val.nombre}
                  </option>
                ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MarcaFormGroup)
